import * as React from "react"

import { FormattedMessage, useIntl } from "react-intl"
import { Heading } from "@walmart-web/livingdesign-components"
import { collapseSideBar } from "context/applicationContext"

import NoResultsImage from "assets/images/error/search_page_error.svg"
import { useFetchData } from "components/Shared/Hooks/react-query/useFetchData"
import ContextualHeader, {
	createBreadcrumbsTranslated,
} from "components/Shared/ContextualHeader"
import DisplayError from "components/Shared/DisplayError"
import MessageComponent, { Message } from "components/Shared/AlertMessage"
import { getSelloutReports } from "components/Transactional/SelloutReport/service"
import ReportsTable from "components/Transactional/SelloutReport/ReportsTable"
import {
	BREADCRUMB_OPTIONS,
	MESSAGE_HINT,
	NO_RESULT_MESSAGE,
} from "components/Transactional/SelloutReport/constants"
import { ReportMapEntry } from "components/Transactional/SelloutReport/reports.mapper"
import "./index.scss"

const DisplayNoResultMessage: React.FC<any> = ({ data, isFetching }) => {
	return data.length === 0 && !isFetching ? (
		<DisplayError
			error={NO_RESULT_MESSAGE}
			img={NoResultsImage}
			hasRetry={false}
		/>
	) : null
}

const SelloutReport: React.FC = (): JSX.Element => {
	collapseSideBar()
	const intl = useIntl()
	const [message, setMessage] = React.useState<Message>()

	const {
		data = [],
		isFetching,
		refetch: refetchSelloutReports,
		remove: removeSelloutReportsCacheQuery,
	} = useFetchData<Array<ReportMapEntry>>("reports", getSelloutReports)

	React.useEffect(() => {
		if (message?.type === "error") {
			removeSelloutReportsCacheQuery()
			refetchSelloutReports()
		}
	}, [message])

	return (
		<div className="sellout-report-container">
			<div className="sub-header">
				<ContextualHeader
					breadcrumbs={createBreadcrumbsTranslated(intl, BREADCRUMB_OPTIONS)}
				/>
				<div className="sub-header-title">
					<Heading role="sub-heading" UNSAFE_className="heading" as="h1">
						<FormattedMessage id="phronesis.sellout_report.application.reporting_sellout.title" />
					</Heading>
				</div>
			</div>
			<div>
				<MessageComponent message={MESSAGE_HINT} setMessage={setMessage} />
			</div>
			<div className="sellout-report-download-message">
				{message && (
					<MessageComponent message={message} setMessage={setMessage} />
				)}
			</div>
			<ReportsTable
				isFetching={isFetching}
				data={data}
				setMessage={setMessage}
			/>
			<DisplayNoResultMessage data={data} isFetching={isFetching} />
		</div>
	)
}

export default SelloutReport
